var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({class:['app-icon', _vm.customClass],attrs:{"width":_vm.computedWidth,"height":_vm.computedHeight,"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":("#icon-" + _vm.name),"href":("#icon-" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }